import { render, staticRenderFns } from "./PageTopSaveButton.vue?vue&type=template&id=0e998743"
import script from "./PageTopSaveButton.vue?vue&type=script&lang=ts"
export * from "./PageTopSaveButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports